import Body from '@ausbom/body/lib/Body';
import Typography from '@ausbom/typography/lib/Typography';
import AppHero from '../../components/AppHero/AppHero';
import Page from '../../components/Page/Page';

export default function PageNotFound() {
  return (
    <>
      <AppHero title="Page not found" isoBars={1} />
      <Page>
        <Body>
          <Typography as="h3" styleName="heading-s" isResponsive>
            The page is not available or the address does not exist
          </Typography>
          <Typography as="p" styleName="body" isResponsive>
            Use the menu options to choose another page, or check the address and try again.
          </Typography>
        </Body>
      </Page>
    </>
  );
}
